import { render, staticRenderFns } from "./People-comp.vue?vue&type=template&id=9945aa78&scoped=true&"
import script from "./People-comp.vue?vue&type=script&lang=js&"
export * from "./People-comp.vue?vue&type=script&lang=js&"
import style0 from "./People-comp.vue?vue&type=style&index=0&id=9945aa78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9945aa78",
  null
  
)

export default component.exports